<div class="add-custom-overrides-dialog">
  <div class="add-custom-overrides-dialog-header flex-between-center">
    <!-- <p class="m-0 font-bold">{{ isMultiLocationEnabled ? 'Switch location' : 'Location' }}</p> -->
    <p class="m-0 font-18 font-600">{{isUpdate ? 'Edit': 'Add'}} Custom Overrides</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="add-custom-overrides-dialog-body flex-column flex-wrap flex-start-start">
    <div>Name Your Custom Override</div>
    <app-input
      id="create-update-custom-override"
      class="w-100"
      placeholder=""
      [value]="customOverride"
      theme="border"
      [floatingLabel]="false"
      (appChange)="handleChange($event)"
      ></app-input>
  </div>

  <div class="add-custom-overrides-dialog-footer">
    <div class="flex-end-center">
      <button class="btn btn-white btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
      <button class="btn btn-primary btn-submit" (click)="handleSave()">
        Save
      </button>
    </div>
  </div>
</div>
